import React from 'react';
import { Col, Row } from 'antd';
import { isNil } from 'lodash';

import { getPayRateTypeLabel } from 'utils/assignmentUtils';
import { AssignmentMultiRateViewModel } from 'api/backofficeApiClient';
import BaseIndicatorNumber from 'components/wrappers/BaseIndicatorNumber';
import { formatNumberAsCurrency } from 'utils/numberUtils';

type Props = {
  multiRates: AssignmentMultiRateViewModel[];
  currentPage: number;
  renderChangesEffectiveDateBtn: () => React.ReactNode;
};

export default function MultipleRatesDetails(props: Props) {
  const { multiRates, currentPage, renderChangesEffectiveDateBtn } = props;

  return (
    <Row gutter={[8, 8]} className="titled-sheet">
      {multiRates.map((multiRate, index) => {
        if (currentPage !== index + 2) return null;

        return (
          <React.Fragment key={index}>
            {!isNil(multiRate.payType) && (
              <Col xs={24} md={12}>
                <div className="title">
                  <BaseIndicatorNumber
                    number={index + 2}
                    title="Pay rate type:"
                  />
                </div>
                <div>{getPayRateTypeLabel(multiRate?.payType)?.title}</div>
              </Col>
            )}
            {!isNil(multiRate.payRate) && (
              <Col xs={24} md={12}>
                <div className="title">
                  <BaseIndicatorNumber number={index + 2} title="Pay rate:" />
                </div>
                <div>
                  {formatNumberAsCurrency({
                    num: multiRate?.payRate,
                  })}
                </div>
              </Col>
            )}
            {!isNil(multiRate.specialInstuctions) && (
              <Col xs={24} md={12}>
                <div className="title">Special instructions:</div>
                <div>{multiRate?.specialInstuctions}</div>
              </Col>
            )}
            {!isNil(multiRate.billRate) && (
              <Col xs={24} md={12}>
                <div className="title">
                  <BaseIndicatorNumber number={index + 2} title="Bill rate:" />
                </div>
                <div>
                  {formatNumberAsCurrency({
                    num: multiRate?.billRate,
                  })}
                </div>
              </Col>
            )}
            {renderChangesEffectiveDateBtn()}
          </React.Fragment>
        );
      })}
    </Row>
  );
}
